import moment from "moment-timezone";

export const convertCompetitionDate = (date) => {
    return moment(date.toDate()).format('DD MMMM');
};